module.exports = __webpack_public_path__ + "img/brands-p-500.0fb972b0.png";